import { RespostaItem }  from './resposta-item';
import { FileUpload }  from './file-upload';

export class Resposta {
  public id: number;
  // public dataCriacao: string;
  public dataCriacao: Date;
  public codigoUsuario: number;
  public usuario: string;
  public questionario: number;
  public salvarConcluir: boolean;
  public situacao: number;
  // variavel transient
  public listaRespostaItem:RespostaItem[];
  public listaRespostaItemArquivo: FileUpload[];
  public parametroMetodoValidador:string;
}
